import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import { RouteUrls } from "../configs/routeUrls";

import { currentBuildVersion } from "../version";

export const UEInfo = ({ officeFooter, legalDocument = null, ...props }) => (
  <Fragment>
    <div className="container bottom-info">
      <div className="bottom-info__name-of-department">
        &copy; {officeFooter.name || ""}
      </div>
      {legalDocument && legalDocument.isActive && (
        <div className="bottom-info__legalDocument">
          <NavLink
            className="link"
            to={RouteUrls.App.legalDocument}
            title={legalDocument.title}
          >
            <span aria-hidden="true">{legalDocument.displayText}</span>
          </NavLink>
        </div>
      )}
      <div className="bottom-info__made-by">
        Serwis utworzony przez{" "}
        <a
          className="bottom-info__link"
          href="http://sputnik.pl"
          target="_blank"
          title="Przejdź do strony wykonawcy serwisu Nefeni Sp. z o.o"
        >
          <span aria-hidden="true">Nefeni Sp. z o.o.</span>
        </a>
        <div className="version-info">
          wersja: {props.appVersion} ({currentBuildVersion})
        </div>
      </div>
    </div>

    <div className="ue">
      {props.applicationImages && props.applicationImages.ue && (
        <img
          className="ue__img"
          src={`data:${props.applicationImages.ueContentType};base64,${props.applicationImages.ue}`}
          alt="Logotypy"
          title="Logotypy"
        />
      )}
    </div>
  </Fragment>
);
